<template>
    <div v-if="(needUpdate || searching)">
        <b-alert show variant="success" class="ml-5 mr-5 mt-2" :class="{'alert-backdrop-blur': !loggedIn}" v-if="needUpdate">
            <div class="update-container">
                <span class="text-center" v-if="thereArePendingInspections">
                    Atualizações disponíveis:
                    <br>
                    É recomendado enviar as inspeções pendentes antes de atualizar
                </span>
                <span class="text-center" v-else-if="needRefresh && !existeNovaVersaoDados">Nova versão disponível:</span>
                <span class="text-center" v-else-if="!needRefresh && existeNovaVersaoDados">Sincronizar dados:</span>
                <span class="text-center" v-else>Atualizações disponíveis:</span>
                <button class="update-btn" @click="downloadUpdates()">
                    <div class="downloading-icon">
                        <div class="chevron" :class="{'chevron-moving': updating}"></div>
                        <div class="chevron" :class="{'chevron-moving': updating}"></div>
                        <div class="chevron" :class="{'chevron-moving': updating}"></div>
                    </div>
                </button>
            </div>
        </b-alert>

        <b-alert show variant="info" v-else class="ml-5 mr-5 mt-2" :class="{'alert-backdrop-blur': !loggedIn}">
            <div class="update-container">
                <span class="text-center" v-if="searching">Buscando atualizações...</span>
                <span class="text-center" v-else>Buscar atualizações:</span>
                <button class="update-btn" @click="lookForUpdates()">
                    <font-awesome-icon icon="sync" :spin="searching"></font-awesome-icon>
                </button>
            </div>
        </b-alert>
    </div>
</template>

<script>
import { BAlert } from "bootstrap-vue";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faSync } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add([faSync]);

import Swal from "sweetalert2";

import Database from "@/controller/database";
import downloadAllVexData from "@/controller/downloadAllVexData";
import VersaoDeDados from "@/controller/versaoDeDados";
import useRegisterSW from "@/mixins/useRegisterSW";
import buscarPneusDinamicos from "@/services/vex/buscarPneus";

export default {
    mixins: [useRegisterSW],
    emits: ["startSearch", "endSearch", "updateFound", "startUpdate", "endUpdate", "visible", "hidden"],
    components: {
        "font-awesome-icon": FontAwesomeIcon,
        BAlert
    },
    data: function () {
        return {
            updating: false,
            searching: false,
            existeNovaVersaoDados: false,
            thereArePendingInspections: false,
            loggedIn: false
        };
    },
    methods: {
        async checkPendingInspections() {
            const database = new Database();
            await database
                .createOrOpenDatabase({ listInspection: true })
                .then((response) => (this.inspections = response))
                .catch(() => (this.inspections = []));

            for (let i = 0; i < this.inspections.length; i++) {
                let vistoria = this.inspections[i];
                if (vistoria.status == "Pendente") {
                    this.thereArePendingInspections = true;
                    break;
                }
            }
        },
        async lookForVersaoDadosUpdate() {
            const versaoDeDados = new VersaoDeDados();
            const versaoDadosEstaAtualizada = await versaoDeDados.versaoDeDadosAtualizada();
            return !versaoDadosEstaAtualizada;
        },
        async lookForUpdates({blocking} = {blocking: false}) {
            if(!this.searching) {
                if(navigator.onLine) {
                    this.$emit("startSearch", {blocking: blocking});
                    this.searching = true;
                    
                    try {
                        let existeNovaVersaoDados = false;
                        if(this.loggedIn) {
                            await this.checkPendingInspections();
                            existeNovaVersaoDados = await this.lookForVersaoDadosUpdate();
                        }
    
                        let hasSWUpdate = false;
                        if (this.registration != null) {
                            // Medindo tempo desde a última checagem de atualização de SW
                            let minutesPassedSinceLastCheck = 9999;
    
                            const lastCheckTimestamp = JSON.parse(sessionStorage.getItem("lastSWUpdateCheck"));
                            
                            if(lastCheckTimestamp != null) {
                                const currentMinute = Math.floor(Date.now() / 1000 / 60);
                                const lastCheckMinute = Math.floor(lastCheckTimestamp / 1000 / 60);
                                minutesPassedSinceLastCheck = currentMinute - lastCheckMinute;
                            }
                            // Espera 5 minutos antes de checar por atualizações do SW novamente
                            if(minutesPassedSinceLastCheck >= 5){
                                try {
                                    // eslint-disable-next-line no-unused-vars
                                    hasSWUpdate = await this.checkForSWUpdate();
                                    sessionStorage.setItem("lastSWUpdateCheck", JSON.stringify(Date.now()));
                                } catch (error) {
                                    console.error("Erro ao tentar procurar por atualizações no servidor:", error);
                                }
                            }
                        }
                        
                        this.existeNovaVersaoDados = existeNovaVersaoDados;
                        const hasUpdate = this.existeNovaVersaoDados || this.needRefresh;
                        this.searching = false;
                        this.$emit("endSearch", {updateFound: hasUpdate});
                        return hasUpdate;
                    } catch (error) {
                        this.searching = false;
                        throw error;
                    }
                } else {
                    return false;
                }
            }
        },
        async downloadUpdates() {
            let atualizacaoLiberada = true;

            if(this.thereArePendingInspections) {
                const result = await Swal.fire({
                    title: "Vistorias pendentes para o envio!",
                    text: "Realmente deseja atualizar antes de enviar as vistorias pendentes? Pode haver perda de dados",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Atualizar",
                    cancelButtonText: "Cancelar",
                    reverseButtons: true
                });

                atualizacaoLiberada = result.isConfirmed;
            }

            if(!this.updating && atualizacaoLiberada){
                this.updating = true;
                this.$emit("startUpdate");
                if (this.existeNovaVersaoDados && this.loggedIn) {
                    const enterpriseToken = this.$store.state.enterprise.enterprise;
                    console.log("Atualizando versão de dados...");
                    await downloadAllVexData(enterpriseToken);
                    this.existeNovaVersaoDados = false;
                    console.log("Atualização finalizada");
                }
                if (this.needRefresh) {
                    this.updateServiceWorker();
                } else {
                    this.updating = false;
                    this.$emit("endUpdate");
                }
            }
        }
    },
    created: async function () {
        this.loggedIn = JSON.parse(localStorage.getItem("enterprise")) == null ? false : true;
    },
    watch: {
        needRefresh: function (newValue, oldValue) {
            if(newValue && this.searching) {
                this.searching = false;
                this.$emit("endSearch", {updateFound: true});
            }
            if(newValue) {
                this.checkPendingInspections();
                this.$emit("updateFound");
            }
        },
        visible: function (newValue) {
            if(newValue === true) {
                this.$emit("visible");
            } else {
                this.$emit("hidden");
            }
        },
        registered(valor) {
            if (valor === true && this.loggedIn) {
                buscarPneusDinamicos();
            }
        }
    },
    computed: {
        needUpdate: function() {
            return this.needRefresh || this.existeNovaVersaoDados;
        },
        visible() {
            return this.needUpdate || this.searching;
        }
    }
};
</script>

<style lang="scss" scoped>

.alert-backdrop-blur {
    color: white;
    backdrop-filter: blur(16px);
    &.alert-info {
        background-color: rgba(161, 217, 226, 0.5);
    }

    &.alert-success {
        background-color: rgba(169, 219, 180, 0.5);
    }
}


.dropdown-white {
    background-color: white;
}

.update-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
    gap: 15px;
}

.update-btn{
    width: 40px;
    height: 40px;
    min-width: 40px;
    min-height: 40px;
    border-radius: 0.25rem;
    padding: 0;
    font-size: 1rem;
    line-height: 1.5;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    border: 1px solid transparent;
    background-color: #3fe471;
    transition: all 0.15s ease-in-out;

    &:not(:disabled):active {
        background-color: #37C763;
        color: white;
    }

    &:disabled {
        opacity: 50%;
        color: #778088;
        cursor: not-allowed;
    }

    > .fa-sync{
       border: 2px solid currentColor;
       padding: 5px;
       border-radius: 50%;
    }
}
</style>

<style lang="scss" scoped>
$base: 3px;

.downloading-icon {
    width: $base * 5;
    height: $base * 8.5;
    display: flex;
    align-items: start;
    justify-content: center;
}

.chevron {
    position: absolute;
    width: $base * 3.5;
    height: $base * 0.8;
}

.chevron:not(.chevron-moving) {
    transform: translateY($base * 2.3);
}

.chevron:not(.chevron-moving):first-child {
    transform: translateY($base * 3.8);
}

.chevron:not(.chevron-moving):nth-child(2) {
    transform: translateY($base * 5.3);
}

.chevron-moving {
    opacity: 0;
    animation: move-chevron 3s ease-out infinite;
}

.chevron-moving:first-child {
    animation: move-chevron 3s ease-out 1s infinite;
}

.chevron-moving:nth-child(2) {
    animation: move-chevron 3s ease-out 2s infinite;
}

.chevron:before,
.chevron:after {
    content: '';
    position: absolute;
    top: 0;
    height: 100%;
    width: 50%;
    background: currentColor;
}

.chevron:before {
    left: 0;
    transform: skewY(30deg);
}

.chevron:after {
    right: 0;
    width: 50%;
    transform: skewY(-30deg);
}

@keyframes move-chevron {
    25% {
        opacity: 1;
    }

    33.3% {
        opacity: 1;
        transform: translateY($base * 3.8);
    }

    66.6% {
        opacity: 1;
        transform: translateY($base * 5.2);
    }

    100% {
        opacity: 0;
        transform: translateY($base * 8);
    }
}
</style>
